import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Booking } from "./api/booking";
import { ApiError, useEloApi } from "./api/api";
import { useError } from "./contexts/ErrorContext";
import { User } from "./api/users";
import { EditBooking } from "./pages/EditBooking.page";
import { Anchor, Card, Center, Loader, Stack, Text, Title } from "@mantine/core";
import { IconAlertCircleFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export const CheckBooking = () => {
  const { bookingUrl } = useParams();
  const { t } = useTranslation();

  const api = useEloApi({});
  const errorContext = useError();

  const [loading, setLoading] = useState(true);

  const [localUser, setLocalUser] = useState<User | undefined>();
  const getUser = useCallback(async (userId: string) => {
    try {
      const res = await api.getUser(undefined, userId);
      setLocalUser(res);
    } catch (e) {
      console.error(e);
      if (e instanceof ApiError) {
        errorContext.setError(e.message);
      } else {
        throw e;
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const [booking, setBooking] = useState<Booking | undefined>();
  const getBooking = useCallback(async () => {
    if (!bookingUrl) return;
    setLoading(true);

    try {
      const res = await api.getBookingWithUrl(bookingUrl);
      setBooking(res);
      await getUser(res.userId);
    } catch(e) {
      console.error(e);
      if (e instanceof ApiError) {
        errorContext.setError(e.message);
      } else {
        throw e;
      }
    }

  }, [bookingUrl]);

  useEffect(() => {
    getBooking();
  }, []);

  return loading ? (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100dvh',
        backgroundColor: `var(--mantine-background)`,
      }}
    >
      <Center style={{margin: "auto"}}><Loader></Loader></Center>
    </div>
  ) : (booking && localUser ? (
    <EditBooking editBooking={booking} localUser={localUser} extension={localUser.bookingUrl} /> 
  ) : (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100dvh',
        backgroundColor: `var(--mantine-background)`,
      }}
    >
      <Card
        shadow="sm"
        padding="lg"
        radius="md"
        withBorder
        style={{
          margin: 'auto',
          position: 'relative',
        }}
      >
        <Stack justify="center" align="center">
          <IconAlertCircleFilled size={128} color="var(--mantine-color-red-7)" />
          <Title order={2}>ERROR</Title>
          {localUser ? (
            <>
              <Text>{t("verify_psychologist_error.booking_link_not_found")}</Text>
              <Anchor size="xs" href={`${window.location.origin}/agendar/${localUser.bookingUrl}`}>
                {t("verify_psychologist_error.do_booking")}
              </Anchor>
            </>
          ) : (
            <>
              <Text>{t("verify_psychologist_error.link_not_found")}</Text>
            </>
          )}
        </Stack>
      </Card>
    </div>
  ))
}